import React from 'react'

export default function () {
    return (
        <div className="container-fluid d-none d-lg-block my-5 text-center">
          <div className="row">
          {/**Starting Single Column */}
        <div className="col-lg-2">
            <p className="text-uppercase">
                Products
            </p>
        </div>
          {/**Ending Single Column */}
                    {/**Starting Single Column */}
        <div className="col-lg-2">
            <p className="text-uppercase">
                name of product
            </p>
        </div>
          {/**Ending Single Column */}
                            {/**Starting Price Column */}
        <div className="col-lg-2">
            <p className="text-uppercase">
                Price
            </p>
        </div>
          {/**Ending Price Column */}
                    {/**Starting Single Column */}
        <div className="col-lg-2">
            <p className="text-uppercase">
              quantity
            </p>
        </div>
          {/**Ending Single Column */}
                    {/**Starting Single Column */}
        <div className="col-lg-2">
            <p className="text-uppercase">
                remove
            </p>
        </div>
          {/**Ending Single Column */}
                    {/**Starting Single Column */}
        <div className="col-lg-2">
            <p className="text-uppercase">
                total
            </p>
        </div>
          {/**Ending Single Column */}

          </div>
        </div>
    )
}
